var render, staticRenderFns
import script from "./SharedBandForm.vue?vue&type=script&lang=js&"
export * from "./SharedBandForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/code/nathan/Sonido_SaaS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f53bb3e')) {
      api.createRecord('5f53bb3e', component.options)
    } else {
      api.reload('5f53bb3e', component.options)
    }
    
  }
}
component.options.__file = "resources/assets/src/components/shared/SharedBandForm.vue"
export default component.exports